
import React from 'react';

interface EditorButtonGroupProps {
  children: React.ReactNode;
}

const EditorButtonGroup = ({ children }: EditorButtonGroupProps) => (
  <div className="flex items-center mr-1">
    {children}
    <div className="h-4 border-r mx-1 last:hidden dark:border-gray-600"></div>
  </div>
);

export default EditorButtonGroup;
